import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IDiscountRepository } from '../../repositories/interfaces/iDiscountRepository';
import { CSRFTokenRequest } from '../../../entity';
import { IActiveSubscriptionRedeeemGiftCardResponse } from '../../../entity/interface/iDiscounts';
import { AxiosError } from 'axios';
export interface IActiveSubscriptionRedeeemGiftCardUseCase {
    execute(
        username: string,
        identityToken: string,
        discountCode: string,
        token: string,
        csrfToken: CSRFTokenRequest
    ): Promise<IActiveSubscriptionRedeeemGiftCardResponse>;
}

export class ActiveSubscriptionRedeeemGiftCardUseCase implements IActiveSubscriptionRedeeemGiftCardUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get activeSubRedeem(): IDiscountRepository {
        return container.resolve<IDiscountRepository>(DI.REPOSITORIES.IDiscountRepository);
    }
    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        username: string,
        identityToken: string,
        discountCode: string,
        token: string,
        csrfToken: CSRFTokenRequest
    ): Promise<IActiveSubscriptionRedeeemGiftCardResponse> {
        const response = await this.activeSubRedeem.activeSubscriptionRedeeemGiftCard(
            username,
            identityToken,
            discountCode,
            token,
            csrfToken
        );
        if (response.data) {
            // Assuming response also contains txRef, and possibly an error object
            return {
                txRef: response.txRef, // This must be provided by your repository response
                data: response.data,
            };
        }
        throw new AxiosError('Invalid response from API', '500');
    }
}
